"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Color = void 0;
var Color;
(function (Color) {
    Color["Alpha_30"] = "rgba(0, 0, 0, 0.3)";
    Color["Background"] = "#f5f3f0";
    Color["Black"] = "#000";
    Color["Error"] = "#cb444b";
    Color["Primary"] = "#333";
    Color["Secondary"] = "#999999";
    Color["Success"] = "#00BA88";
    Color["Input_Success"] = "#0D8F6C";
    Color["Surface"] = "#fff";
    Color["Variant_1"] = "#d9d9d9";
})(Color = exports.Color || (exports.Color = {}));
